const Constant = {
    ACCESS_TOKEN: null,
    token: 'd6d4685417ef2287424ffda3b0f88746',
    REFRESH_TOKEN: 'REFRESH_TOKEN',
    USER_ID: 'USER_ID',
    API_KEY: 'API_KEY',
    API_BASE_URL_LOCAL: 'http://medapp-backend.test/medapp/api/',
    API_BASE_URL_TEST: 'http://139.255.24.122:1180/medapp-v2/medapp/api/',
    API_BASE_URL_PROD: 'https://app-medapp.eksad.com/medapp-v2/medapp/api/',
    API_VERSION_1: 'v1',
    API_VERSION_2: 'v2',
    LOGIN: null,
    BASE_URL: 'http://139.255.24.122:8080/',
    DATA_FAQ: 'DATA_FAQ',
    DATA_PROMOSI: 'DATA_PROMOSI',
    API_KEY_GOOGLE: 'AIzaSyA622HDjJdfsDiDd9lVBmd_qj9Kntt03g8',
    API_KEY_GOOGLE_DEV: 'AIzaSyBg5o1YmD277csOg1fDuegYnp95yn1be0I',
    NAMA_RS: 'NAMA_RS',
    LOGO_RS: 'LOGO_RS',
    ALAMAT_RS: 'ALAMAT_RS',
    PHONE_RS: 'PHONE_RS',
    LOGO_CETAKAN: 'LOGO_CETAKAN',
    DESCRIPTION_RS: 'DESCRIPTION_RS',
    SIPA: 'SIPA',
    APOTEKER: 'APOTEKER',
    CURRENT_COUNTER: 'CURRENT_COUNTER',
    SUB_FACILITY: 'SUB_FACILITY',
    PUSHER_APP_ID: '1254300',
    PUSHER_APP_KEY: 'ffbbe48d97d3c66f1ffe',
    PUSHER_APP_SECRET: '1197701e19167c2ca895',
    PUSHER_APP_CLUSTER: 'ap1'
}

export default Constant;